import { createStore } from 'vuex';

import rootStore from '@/store/rootStore';

export default createStore(rootStore);
